import CallToAction from "@/components/Button";
import { SVGArrowRight } from "@/lib/svg";
import { H2, P, MainWrapper } from "@/lib/styles";
import styled from "styled-components";

export const BackgroundContainer = styled.div`
  position: relative;
  padding-bottom: 2.5rem;
  background-color: ${({ theme }) => theme.colors.lightGrey};

  opacity: 0;
  transform: translateY(100px);
`;

export const Container = styled(MainWrapper)`
  ${({ theme }) => theme.mediaQueries.laptop} {
    display: flex;
  }
`

export const TextContainer = styled.div`
  margin-bottom: 3.75rem;
  position: sticky;
  align-items: flex-start;
  height: max-content;
  padding-top: 4rem;

  ${({ theme }) => theme.mediaQueries.laptop} {
    flex: 1;
    margin-bottom: 0;
    top: ${({ theme }) => theme.space.headerMinHeight};
  }
`;

export const BulletPointsContainer = styled.div`
  text-align: right;
  ${({ theme }) => theme.mediaQueries.laptop} {
    flex: 1;
  }
`;

export const Heading = styled(H2)`
  margin-bottom: 1.5rem;
  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(20px);
  }
`;
export const Excerpt = styled(P)`
  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(20px);
  }
`;

export const PrimaryButton: React.FC<any> = (props) => (
  <CallToAction
    as="a"
    variant="primaryBoxed"
    icon={<SVGArrowRight />}
    {...props}
  />
);

export const SecondaryButton: React.FC<any> = (props) => (
  <CallToAction
    as="a"
    variant="primaryBoxedNegative"
    icon={<SVGArrowRight />}
    $transparent
    {...props}
  />
);

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;

  & > * {
    opacity: 0;
    transform: translateY(20px);
  }
`;
